export const accessOptions = [
  {label: "ADMIN", value: "ADMIN"},
  {label: "SALES", value: "SALES"},
  {label: "SUPERVISOR", value: "SUPERVISOR"},
  {label: "PRICE", value: "PRICE"}
]